import { createApp } from 'vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

/**
 * Opens a confirmation modal and resolves to true if the user confirmed.
 * @param {{ title?: string, message?: string, confirmText?: string, cancelText?: string }} options
 * @returns {Promise<boolean>}
 */
export function confirm(options = {}) {
  return new Promise(resolve => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const app = createApp(ConfirmModal, {
      ...options,
      onConfirm: () => close(true),
      onCancel: () => close(false),
    });

    function close(result) {
      app.unmount();
      container.remove();
      resolve(result);
    }

    app.mount(container);
  });
}

export default {
  install(app) {
    app.config.globalProperties.$confirm = confirm;
  },
};
